Belimo.Search = {
    views: {},
    addView(name, view) {
        this.views[name] = view;
    },
    getView(name) {
        return this.views[name];
    },
    getViews() {
        return this.views;
    }
};

const fetchJson = async (url) => {
	const response = await fetch(url);
	if(response.status < 200 || response.status >= 300) {
		throw new Error(`Unexpected response code '${response.status}' from request to '${url}'`);
	}

	const contentType = response.headers.get('content-type');
	if(contentType !== null && !contentType.toLowerCase().startsWith('application/json')) {
		throw new Error(`Unexpected content-type '${contentType}' from request to '${url}'`);
	}

	const responseJson = await response.json();
	return responseJson;
};

Belimo.fetchJson = async (url) => {
	try {
		return await fetchJson(url);
	}
	catch (error) {
		console.error(`Error fetching '${url}', ${error}`);
		return null;
	}
};

Belimo.fetchJsonAndSetAsText = async (url, cssSelectorGroup, defaultTextValue, textPrefix = '', textSuffix = '') => {
    if (!cssSelectorGroup || !url) return;
    const resultJson = await Belimo.fetchJson(url);

    const resultJsonAsText = resultJson !== null
        ? JSON.stringify(resultJson)
        : (defaultTextValue || '');

    const domElemTextContent = `${textPrefix}${resultJsonAsText}${textSuffix}`;
    const domElems = document.querySelectorAll(cssSelectorGroup);

    for (const domElem of domElems) {
        domElem.textContent = domElemTextContent;
    }
};
